/****************ELEMENTS*****************/
//this obj define, the actions realeted to each 
//th>table header and td

const timeDate = require ('../../../../../js-handler/time-date')

export const tableDetail = {
    entity: 'transaction',//name table on the db
    dest: 'transaction',//name of the entity on the system

    //action for body 
    //left click, directly to the fullcont 
    tdDataDetail:`data-detail='{ "click": [ {"dest":"ripple" } ],
                                
                                 "clickRight": [{"dest":"transaction", "elem":"dt", "act":"trMenu", "id":"trMenu",  "entity":"transaction", "dbid": "#dbid" } ]  }'`,

    filter: {
        mainFilterFields : ["transaction.entity","transaction.account"],
        mainFilterValues : ["", ""],         
        andFilterFields  : [""],
        andFilterValues  : [""],  
    }
}

/****************ELEMENTS*****************/

//each element could organize their data diferent
export function organizeRow(data){ 
    
    console.log('organizeRow>')

    var newData = []

    if(data.length === 0){
        newData.push({   id: 'nothing', colum: [{ label:'No Results', span: ''},
                                                { label:'', span: '' }, 
                                                { label:'', span: '' },
                                                { label:'', span: '' },
                                                { label:'', span: '' }] })
        return newData
    }

    data.forEach((elem)=>{

        let textType;
        let benefitAvatar;

        if (elem.customer_id == '') {
            benefitAvatar = elem.providerAvatar
        }else if(elem.provider_id == ''){
            benefitAvatar = elem.customerAvatar
        }else{
            console.log('no avatar')
        }

        switch (elem.action) {
            case 'out':
              textType = 'Sent';
              break;

            case 'in':
              textType = 'Received';
              break;

            default:
              break;
        } 

let letter      = "";
let avatarColor = "";
let avatarColorLetter = "";
let avatar      = "";
let name = "";

// Verificar si el provider tiene avatar; si no, usar la letra del provider
if (elem.providerAvatar) {
    avatar = elem.providerAvatar;
} else if (elem.providerAvatarLetter) {
    letter = elem.providerAvatarLetter;
}

if (elem.providerName) {
    name = elem.providerName;
} else {
    name = elem.customerName;
}

// Si no hay avatar del provider, verificar si el customer tiene avatar; si no, usar la letra del customer
if (!avatar) {  // Solo si no se asignó avatar del provider
    if (elem.customerAvatar) {
        avatar = elem.customerAvatar;
    } else if (elem.customerAvatarLetter) {
        letter = elem.customerAvatarLetter;
    }
}

// Verificar y asignar el color de avatar
if (!elem.customerAvatarColor && !elem.providerAvatarColor) {
    avatarColor = '12af45';
} else if (!elem.customerAvatarColor) {
    avatarColor = elem.providerAvatarColor;
} else if (!elem.providerAvatarColor) {
    avatarColor = elem.customerAvatarColor;
}

// Verificar y asignar el color de letra del avatar
if (!elem.customerAvatarColorLetter && !elem.providerAvatarColorLetter) {
    avatarColorLetter = '12af45';
} else if (!elem.customerAvatarColorLetter) {
    avatarColorLetter = elem.providerAvatarColorLetter;
} else if (!elem.providerAvatarColorLetter) {
    avatarColorLetter = elem.customerAvatarColorLetter;
}



        newData.push(
            {   id: elem.id,   colum: [  { label: elem.entity,  }, 
                                         { label: elem.accountName  , span: elem.typeUser,  
                                            style:{ 
                                            tdClass:'tdWithAvatar',  
                                            avatar:elem.accountAvatar,
                                                avatarColor: elem.accountAvatarColor, 
                                                avatarColorLetter: elem.accountAvatarColorLetter, 
                                                avatarLetter: elem.accountAvatarLetter  
                                            
                                            }
                                         },
                                         { label: textType, span: name,style:{ 
                                            tdClass:'tdWithAvatar',  
                                            avatar:avatar,
                                            avatarColor: avatarColor, 
                                            avatarColorLetter: avatarColorLetter,
                                            avatarLetter: letter 
                                            
                                            }
                                        },
                                         { label: elem.transactionAmount, span: timeDate.friendlyTime(elem.date_time)},
                                         { label: timeDate.friendlyDate(elem.date) , span: timeDate.friendlyTime(elem.date_time)}
                                      ]    
            }
        )/*push*/
    })/*forEach*/

    return newData
}/*organizeRow*/